//
// ViewportOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../core/GTLModel";
import "./ViewportFitPolicy";
import "../../core/HorizontalAlignment";
import "../../core/VerticalAlignment";
import "./ViewportLimits";

var ViewportOptions = createModule("gtl::ViewportOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        initialVAlign: 4,
        viewportLimits: 4,
        initialFitPolicy: 4,
        resetViewportForNewDataModel: 2,
        initialHAlign: 4,
    },
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_b: [4,2],
    },
    ,
    ["_create"]
]);
export default ViewportOptions;
